import { EventEmitter, inject, Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { App } from '@df/core/app';
import { NDfModuleLoqate } from '../df-module-loqate.config';
import { LoqateService } from '../loqate.service';

export class LoqatePhoneValidationEvent {
    constructor(
        public items: NDfModuleLoqate.PhoneValidationItem[] | undefined,
        public phone: string,
        public error: ValidationErrors | null
    ) {}
}

@Injectable({
    providedIn: 'root'
})
export class LoqatePhoneValidatorService {
    protected app = inject(App);
    protected loqateService = inject(LoqateService);

    async validatorFunction(
        control: AbstractControl,
        countryCode = 'GB',
        eventEmitter?: EventEmitter<LoqatePhoneValidationEvent>
    ): Promise<ValidationErrors | null> {
        if (!control.value?.length || !this.loqateService.isEnabled) {
            return null;
        }

        const items = await this.loqateService.validatePhone(control.value, countryCode);

        let error: ValidationErrors | null = null;

        if (items) {
            error = this.loqateService.getPhoneError(items, control.value);
        }

        if (eventEmitter) {
            eventEmitter.emit(new LoqatePhoneValidationEvent(items, control.value, error));
        }

        return error;
    }

    async validate(
        control: AbstractControl,
        countryCode = 'GB',
        eventEmitter?: EventEmitter<LoqatePhoneValidationEvent>
    ): Promise<ValidationErrors | null> {
        return this.validatorFunction(control, countryCode, eventEmitter);
    }
}
